import React, { useEffect, useState } from "react";
import {
	bannerBike,
	BannerSlide1,
	Benefit1,
	Benefit2,
	Benefit3,
	Benefit4,
	Easy1,
	Easy2,
	EasyBefore,
	LeftBefore,
	Product1,
	Product2,
	Product3,
	Product4,
	ReviewImg1,
	ReviewImg2,
	ReviewImg3,
	ReviewImg4,
} from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import {
	useHomeContentQuery,
	useSiteSettingsQuery,
} from "../../store/services/HomeServices";
import Spinner from "../../utils/Loader";
import { useCategoriesQuery } from "../../store/services/CategoryService";
import { useClientsReviewsQuery } from "../../store/services/ClientsReview";
import { useGetServiceByIdQuery } from "../../store/services/InnerServices";
import { useBenefitsContentQuery } from "../../store/services/FaqsServices";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";

const Home = () => {
	const [proID, setProID] = useState(1);
	const { data, isFetching } = useHomeContentQuery();
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();
	const { data: Response, isFetching: load } = useSiteSettingsQuery();
	const { data: cateResponse, isFetching: cateload } = useCategoriesQuery();
	const { data: beniftResponse, isFetching: beniload } =
		useBenefitsContentQuery();
	const { data: serviceIdResponse, isFetching: prodload } =
		useGetServiceByIdQuery(proID);
	const { data: clientResponse, isFetching: clientreviewload } =
		useClientsReviewsQuery();
	let [limits, setLimit] = useState(4);

	useEffect(() => {
		AOS.init();
		AOS.refresh();
		window.scroll(0, 0);
	}, []);

	return (
		<>
			{!isFetching ? (
				<>
					{/* Header */}
					<Header />
					{/* Header */}

					{/* banner Sec STart Here */}
					<section className="banner_sec">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6">
									<div className="content-wrapper">
										{/* <div className="title-wrapper">
											
											<h2 className="main-title mt-4 pt-3">
												Let us <span className="green">Electrify</span>{" "}
												Everything
											</h2>
										</div>
										<p>
											Dignissim cras tincidunt lobortis feugiat vivamus at augue
											eget. Sociis natoque penatibus et magnis dis parturient.
											Nulla porttitor massa id neque aliquam vestibulum.
										</p> */}
										<h5 className="sub-title">
											<span>Welcome to Flit</span>
										</h5>
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.banner_heading_and_para,
											}}
										></div>
										<div className="button-group">
											{/* <a href="#" className="flit-btn">
										Learn More
									</a> */}
											<Link className="flit-btn" to="/about">
												<span className="for-txt">Learn More</span>{" "}
												<span className="for-hover"></span>
											</Link>
										</div>
									</div>
								</div>
								<div className="col-lg-6">
									<div
										className="image-box"
										data-aos="fade-left"
										data-aos-duration="1000"
									>
										<figure>
											<img
												src={`${ImageUrl?.uploads}${data?.response?.data?.banner_image}`}
												alt=""
												className="img-fluid"
											/>
										</figure>
									</div>
									<div className="recent-bikes">
										<div
											className="bike-box"
											data-aos="fade-up-right"
											data-aos-duration="1000"
										>
											<figure>
												<img
													src={`${ImageUrl?.uploads}${data?.response?.data?.recent_vehicle_1}`}
													alt=""
													className="img-fluid"
												/>
											</figure>
											<Link to="/products">Learn More</Link>
										</div>
										<div
											className="bike-box"
											data-aos="fade-up-right"
											data-aos-duration="1000"
										>
											<figure>
												<img
													src={`${ImageUrl?.uploads}${data?.response?.data?.recent_vehicle_2}`}
													alt=""
													className="img-fluid"
												/>
											</figure>
											<Link to="/products">Learn More</Link>
										</div>
										<div
											className="bike-box"
											data-aos="fade-up-right"
											data-aos-duration="1000"
										>
											<figure>
												<img
													src={`${ImageUrl?.uploads}${data?.response?.data?.recent_vehicle_3}`}
													alt=""
													className="img-fluid"
												/>
											</figure>
											<Link to="/products">Learn More</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* banner Sec End Here */}

					{/* Easy Plan Sec Start Here */}
					<section className="easy-plan">
						<div className="right-before">
							<figure>
								<img src={EasyBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container">
							<div className="heading-wrapper">
								{/* <h2>
									We Provide best E Vehicle <span className="icon">&</span>
									<br />
									<span className="colored">Easy plans To buy</span>
								</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html: data?.response?.data?.content,
									}}
								></div>
							</div>
							<div className="row row-one align-items-center mt-3">
								<div
									className="col-lg-6 order-md-1 order-lg-0"
									data-aos="fade-right"
									data-aos-duration="1000"
								>
									<div className="content-wrapper universal-heading">
										{/* <h3 className="title">
											We Provide best E Vehicle &
											<span className="colored"> Easy plans To buy</span>
										</h3>
										<p>
											Est velit egestas dui id ornare arcu odio ut sem. Congue
											nisi vitae suscipit tellus mauris a. Fringilla phasellus
											faucibus scelerisque eleifend donec pretium vulputate
											sapien. Mus mauris vitae ultricies leo integer malesuada.
											Amet venenatis urna cursus eget nunc scelerisque viverra.
											Mattis pellentesque id nibh tortor id. Lorem ipsum dolor
											sit amet consectetur adipiscing elit ut. Fusce id velit ut
											tortor.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.section_1_content,
											}}
										></div>
										<div className="buttob-group">
											{/* <a href="#" className="flit-btn">
										View Products
									</a> */}
											<Link className="flit-btn" to="/applyforloans">
												<span className="for-txt">Get Loan</span>
												<span className="for-hover"></span>
											</Link>
										</div>
									</div>
								</div>
								<div className="col-lg-6  order-md-0 mb-5 mb-lg-0">
									<div
										className="img-box"
										data-aos="fade-left"
										data-aos-duration="1000"
									>
										<figure>
											<img
												src={`${ImageUrl?.uploads}${data?.response?.data?.section_1_image}`}
												alt=""
												className="img-fluid"
											/>
										</figure>
									</div>
								</div>
							</div>
							<div className="row row-two align-items-center mt-3">
								<div className="col-lg-6">
									<div
										className="img-box"
										data-aos="fade-right"
										data-aos-duration="1000"
									>
										<figure>
											<img
												src={`${ImageUrl?.uploads}${data?.response?.data?.section_2_image}`}
												alt=""
												className="img-fluid"
											/>
										</figure>
									</div>
								</div>
								<div className="col-lg-6 ">
									<div
										className="content-wrapper universal-heading"
										data-aos="fade-left"
										data-aos-duration="1000"
									>
										{/* <h3 className="title">
											We Provide best E Vehicle &
											<span className="colored"> Easy plans To buy</span>
										</h3>
										<p>
											Est velit egestas dui id ornare arcu odio ut sem. Congue
											nisi vitae suscipit tellus mauris a. Fringilla phasellus
											faucibus scelerisque eleifend donec pretium vulputate
											sapien. Mus mauris vitae ultricies leo integer malesuada.
											Amet venenatis urna cursus eget nunc scelerisque viverra.
											Mattis pellentesque id nibh tortor id. Lorem ipsum dolor
											sit amet consectetur adipiscing elit ut. Fusce id velit ut
											tortor.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.section_2_content,
											}}
										></div>
										<div className="buttob-group">
											{/* <a href="#" className="flit-btn">
										View Products
									</a> */}
											<Link className="flit-btn" to="/products">
												<span className="for-txt">View Products</span>
												<span className="for-hover"></span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Easy Plan Sec End Here */}

					{/* Porcess Sec Start Here */}
					<section className="process-sec">
						<div className="left-before">
							<figure>
								<img src={LeftBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container">
							<div className="universal-heading">
								<div
									dangerouslySetInnerHTML={{
										__html: data?.response?.data?.process_heading_and_para,
									}}
								></div>
							</div>
							<div className="row">
								<div
									className="col-lg-3 col-md-6 col-sm-6 px-2 mb-3 mb-lg-0"
									data-aos="flip-left"
									data-aos-easing="ease-out-cubic"
									data-aos-duration="2000"
								>
									<div className="process-box">
										{/* <div className="title">
											<h3>Step 1</h3>
											<h4>Lorem Ipsum</h4>
										</div>
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore magna.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.process_step_1_content,
											}}
										></div>
										<div className="">
											<a href="#" className="lnk">
												Learn More
											</a>
											{/* <Link className="flit-btn" to="/about"><span className="for-txt">Learn More</span> <span className="for-hover"></span></Link> */}
										</div>
									</div>
								</div>
								<div
									className="col-lg-3 col-md-6 col-sm-6 px-2 mb-3 mb-lg-0"
									data-aos="flip-left"
									data-aos-easing="ease-out-cubic"
									data-aos-duration="2000"
								>
									<div className="process-box">
										{/* <div className="title">
											<h3>Step 2</h3>
											<h4>Lorem Ipsum</h4>
										</div>
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore magna.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.process_step_2_content,
											}}
										></div>
										<div className="">
											<a href="#" className="lnk">
												Learn More
											</a>
											{/* <Link className="flit-btn" to="/about"><span className="for-txt">Learn More</span> <span className="for-hover"></span></Link> */}
										</div>
									</div>
								</div>
								<div
									className="col-lg-3 col-md-6 col-sm-6 px-2 mb-3 mb-lg-0"
									data-aos="flip-left"
									data-aos-easing="ease-out-cubic"
									data-aos-duration="2000"
								>
									<div className="process-box">
										{/* <div className="title">
											<h3>Step 3</h3>
											<h4>Lorem Ipsum</h4>
										</div>
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore magna.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.process_step_3_content,
											}}
										></div>
										<div className="">
											<a href="#" className="lnk">
												Learn More
											</a>
											{/* <Link className="flit-btn" to="/about"><span className="for-txt">Learn More</span> <span className="for-hover"></span></Link> */}
										</div>
									</div>
								</div>
								<div
									className="col-lg-3 col-md-6 col-sm-6 px-2 "
									data-aos="flip-left"
									data-aos-easing="ease-out-cubic"
									data-aos-duration="2000"
								>
									<div className="process-box">
										{/* <div className="title">
											<h3>Step 4</h3>
											<h4>Lorem Ipsum</h4>
										</div>
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore magna.
										</p> */}
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data?.process_step_4_content,
											}}
										></div>
										<div className="">
											<a href="#" className="lnk">
												Learn More
											</a>
											{/* <Link className="flit-btn" to="/about"><span className="for-txt">Learn More</span> <span className="for-hover"></span></Link> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Porcess Sec End Here */}

					{/* Our Shop Sec Start Here */}
					<section className="shop_sec">
						<div className="right-before">
							<figure>
								<img src={EasyBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container">
							<div className="universal-heading">
								{/* <h2>
									Browse Best E Vehicle
									<br /> from
									<span className="colored"> Our Shop</span>
								</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html:
											Response?.response?.data[0]?.our_shop_heading_and_para,
									}}
								></div>
							</div>
							<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
								{cateResponse?.response?.data
									?.slice(0, limits)
									?.map((item, index) => {
										return (
											<>
												<li class="nav-item" onClick={() => setProID(item?.id)}>
													<a
														class={`${
															index === 0 ? "nav-link active" : "nav-link"
														}`}
														id={`${`pills-Horwin-tab${index + 1}`}`}
														data-toggle="pill"
														href={`#pills-Horwin${index + 1}`}
														role="tab"
														aria-controls={`pills-Horwin${index + 1}`}
														aria-selected="true"
													>
														{item?.name}
													</a>
												</li>
											</>
										);
									})}
							</ul>
							<div class="tab-content" id="pills-tabContent">
								{/* {serviceIdResponse?.response?.data?.vehicles.map(
									(item, index) => {
										return (
											<>
												<div
													class={`${
														index + 1 === 1
															? "tab-pane fade show active"
															: "tab-pane fade"
													}`}
													id={`pills-Horwin${index + 1}`}
													role="tabpanel"
													aria-labelledby={`pills-Horwin-tab${index + 1}`}
												>
													<div className="row">
														<div className="col-lg-6">
															<div className="product-box">
																<div className="img-box pro-box">
																	<figure>
																		<img
																			src={`${ImageUrl?.uploads}${item?.image}`}
																			alt=""
																			className="img-fluid"
																		/>
																	</figure>
																</div>
																<div className="ti-1">
																	<h3> </h3>

																	<h4>
																		{item?.title} <br></br>{" "}
																		<span className="color-read">
																			<Link
																				className="product-read"
																				to={`productdetail/${item?.id}`}
																			>
																				Read more
																			</Link>
																		</span>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</>
										);
									},
								)} */}
								{serviceIdResponse?.response?.data?.vehicles && (
									<>
										<div
											class="tab-pane fade show active"
											id="pills-Horwin"
											role="tabpanel"
											aria-labelledby="pills-Horwin-tab"
										>
											<div className="row">
												{serviceIdResponse?.response?.data?.vehicles
													?.slice(0, limits)
													?.map((item, index) => {
														return (
															<>
																<div className="col-lg-6">
																	<div className="product-box">
																		<div className="img-box pro-box">
																			<figure>
																				<img
																					src={`${ImageUrl?.uploads}${item?.image}`}
																					alt=""
																					className="img-fluid"
																				/>
																			</figure>
																		</div>
																		<div className="ti-1">
																			<h3> </h3>

																			<h4>
																				{item?.title} <br></br>{" "}
																				<span className="color-read">
																					<Link
																						className="product-read"
																						to={`productdetail/${item?.id}`}
																					>
																						Read more
																					</Link>
																				</span>
																			</h4>
																		</div>
																	</div>
																</div>
															</>
														);
													})}
											</div>
										</div>
										{serviceIdResponse?.response?.data?.vehicles.length <=
											0 && (
											<h3 className="Product_notFound">Products Not Found</h3>
										)}
									</>
								)}
							</div>
						</div>
					</section>
					{/* Our Shop Sec End Here */}

					{/* Benefits Sec Start Here */}
					<section className="benefits">
						<div className="container">
							<div className="universal-heading">
								{/* <h2>
									Benefits that <span className="colored">we Provide</span>
								</h2>
								<p>
									Est velit egestas dui id ornare arcu odio ut sem. Congue nisi
									vitae suscipit tellus mauris a. Fringilla phasellus faucibus
									scelerisque eleifend donec pretium vulputate sapien. Mus
									mauris vitae ultricies leo integer malesuada. Amet venenatis
									urna cursus eget nunc scelerisque viverra.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html:
											Response?.response?.data[0]?.benefits_heading_and_para,
									}}
								></div>
							</div>
							<div className="benefits-box">
								<div className="row">
									{beniftResponse?.response?.data?.map((item, index) => {
										return (
											<div className="col-lg-3 col-md-6 mb-3 mb-lg-0">
												<div className="benefit-dv pr-3">
													<div className="icon-dv">
														<figure>
															<img
																src={`${ImageUrl?.uploads}${item?.icon}`}
																alt=""
																className="img-fluid"
															/>
														</figure>
													</div>
													<div className="txt">
														<h3>{item?.name}</h3>
														<p>{item?.content}</p>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</section>
					{/* Benefits Sec End Here */}

					{/* Client Reviews Sec Start Here */}
					<section className="client-review">
						<div className="before">
							<figure>
								<img src={LeftBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container">
							<div className="universal-heading">
								{/* <h2>
									Have a look at our{" "}
									<span className="colored">Client Reviews</span>
								</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html:
											Response?.response?.data[0]
												?.client_reviews_heading_and_para,
									}}
								></div>
							</div>
							<div className="row">
								{clientResponse?.response?.data?.map((items, index) => {
									return (
										<div
											className="col-xl-3 col-lg-6 col-md-6 px-2 mb-3 mb-xl-0"
											key={index}
										>
											<div className="review-box">
												<div className="topbar">
													<figure>
														<img
															src={`${ImageUrl?.uploads}${items?.image}`}
															alt=""
															className="img-fluid"
														/>
													</figure>
													<div className="name">
														<h4 className="name">{items?.name}</h4>
														<p>{items?.designation} </p>
													</div>
												</div>
												<p>{items?.review}</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</section>
					{/* Client Review Sec End Here */}
					{/* Footer */}
					<Footer />
					{/* Footer */}
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default Home;
